'use strict';

const cookies = require('./cookies');
const ageGateConfig = require('./ageGateConfig');
const setBirthday = require('./setBirthday');

module.exports = function getBirthdayFromCookie () {
  let ageGateCookie = cookies.getItem(ageGateConfig.cookieName);

  if (ageGateCookie) {
    let date = new Date(Number(ageGateCookie));

    // ensure the user has the cookie set for subdomains
    setBirthday(date);

    return date;
  } else {
    return undefined;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-agegate/getBirthdayFromCookie.js